import api from '../api';

/**
 * Fetches tags from the server.
 *
 * @return {Promise<Object>} - The response from the API containing the tags.
 * @throws {Error} - If the request fails.
 */
const getTags = async () => {


  try {
    const response = await api.get(`${process.env.REACT_APP_API_ENDPOINT}/api/tags/get`);

    return response.data;
  } catch (error) {
    console.error('Error fetching tags:', error);
    throw error;
  }
}

export default getTags;
